import Navigation from "../components/navbar";
import TitlePage from "./titlePage";

export default function Home() {
  return (
    <>
      <Navigation />
      <TitlePage />
    </>
  );
}
